import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';

import type { MyWallet } from '@/helpers/interfaces/wallet.interface';
import { axiosI } from '@/plugins';
import { financials as financialsRoutes } from '@/router/financials.routes.enum';
import { usePermissionsStore } from '@/stores/permissoins.store';
import { ApiHandler } from '@/submodules/postman-to-ts/apiHandler';

export const useWalletStore = defineStore('WalletStore', () => {
  const myWallet: Ref<MyWallet | null> = ref(null);
  const getMyWallet = async () => {
    try {
      if (
        !usePermissionsStore().checkAuthentication(
          financialsRoutes.myWallet.meta
        )
      )
        return;
      const { path, method } = ApiHandler.auth.getMyWallet;
      const { data } = await axiosI<MyWallet>(path(), {
        method,
      });
      myWallet.value = data;
    } catch {
      // swallow — wallet fetch failure surfaces via missing myWallet
    }
  };

  return {
    myWallet,
    getMyWallet,
  };
});
